import React from 'react';
import Icon1 from '../../assets/icons/icon1.svg';
import Icon2 from '../../assets/icons/icon2.svg';
import DeliveryIcon from '../../assets/icons/delivery.svg';
import CollectionIcon from '../../assets/icons/collection.svg';
import {IconEat, IconDrink, IconDeliver} from './Icons.style';

export const getIcons = (i, isDeliveryMode) => {
  switch (i) {
    case 0:
      return <IconEat src={Icon1} />;
    case 1:
      return <IconDrink src={Icon2} />;
    case 2:
      return <IconDrink src={isDeliveryMode ? DeliveryIcon : CollectionIcon} />;
    default:
      return <IconDeliver src={DeliveryIcon} />;
  }
};



// WEBPACK FOOTER //
// ./containers/LightHomePage/IconSwitch.js